import React from 'react';
import bestLogo from '../assets/logo-best.jpeg';
import './DashboardShell.css';

const DashboardShell = ({
  brand = 'BTOP Wellness',
  subtitle = 'Dashboard',
  roleLabel = 'User',
  userName = '',
  userInitial = 'B',
  navItems = [],
  activeKey = '',
  onLogout,
  children,
  tone = 'green',
}) => {
  return (
    <div className={`app-shell app-shell-${tone}`}>
      <aside className="app-sidebar" aria-label={`${roleLabel} navigation`}>
        <div className="app-sidebar-brand">
          <div className="app-sidebar-mark">
            <img src={bestLogo} alt="BEST BTOP logo" />
          </div>
          <div>
            <p>{brand}</p>
            <strong>{roleLabel}</strong>
          </div>
        </div>

        <nav className="app-sidebar-nav">
          {navItems.map((item) => (
            <button
              key={item.key}
              type="button"
              className={`app-nav-item ${activeKey === item.key ? 'active' : ''}`}
              onClick={item.onClick}
            >
              <span className={`app-nav-icon app-nav-icon-${item.key}`} aria-hidden="true">
                <span className="app-nav-symbol" />
              </span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="app-sidebar-user">
          <div className="app-sidebar-avatar">{userInitial}</div>
          <div>
            <strong>{userName || roleLabel}</strong>
            <span>{subtitle}</span>
          </div>
        </div>

        {onLogout && (
          <button className="app-sidebar-logout" type="button" onClick={onLogout}>
            Keluar
          </button>
        )}
      </aside>

      <div className="app-shell-main">
        <header className="app-mobile-head">
          <div>
            <p>{brand}</p>
            <strong>{roleLabel}</strong>
          </div>
          <div className="app-mobile-actions">
            <div className="app-mobile-avatar">{userInitial}</div>
            {onLogout && (
              <button className="app-mobile-logout" type="button" onClick={onLogout} aria-label="Keluar">
                <span />
              </button>
            )}
          </div>
        </header>

        {children}
      </div>

      <nav className="app-mobile-nav" aria-label={`${roleLabel} mobile navigation`}>
        {navItems.map((item) => (
          <button
            key={item.key}
            type="button"
            className={`app-mobile-nav-item ${activeKey === item.key ? 'active' : ''}`}
            onClick={item.onClick}
          >
            <span className={`app-mobile-nav-icon app-nav-icon-${item.key}`} aria-hidden="true">
              <span className="app-nav-symbol" />
            </span>
            <small>{item.label}</small>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default DashboardShell;
